import { fromJS } from 'immutable'
import {
  CONFIDENTIAL_EXPORT_REQUEST,
  CONFIDENTIAL_EXPORT_SUCCESS,
  CONFIDENTIAL_EXPORT_FAILURE,
  CONFIDENTIAL_EXPORT_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case CONFIDENTIAL_EXPORT_REQUEST:
      return state
        .set('isFetching', false)
    case CONFIDENTIAL_EXPORT_SUCCESS:
      return state
        .set('url', fromJS(action.payload.url))
        .set('isFetching', false)
    case CONFIDENTIAL_EXPORT_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('isFetching', false)
    case CONFIDENTIAL_EXPORT_RESET:
      return state
        .delete('url')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/confidential/confidential-export-reducer.js